import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '@service/auth/auth.service';
import {IS_FASTAPI_REQUEST} from '@app/http/fastapi-request.context';

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const injector = inject(Injector);
  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (request.context.get(IS_FASTAPI_REQUEST)) {
        return throwError(() => err);
      }
      const auth = injector.get(AuthService);
      if (err.status === 401) {
        queueMicrotask(() => auth.logout());
      }
      return throwError(() => err);
    })
  );
};
